import { Edit16 } from '@yunex/yds-icons';
import { InputAdornment, TextField } from '@yunex/yds-react';
import React, { useState } from 'react';
import { CMP_EDIT_VIEWS_DIALOG as CMP } from '../../../componentNames';
import { CenteredBox } from './CenteredBox';
var styles = {
    textField: {
        width: '100%',
        '&:not(:hover)': {
            border: 'none',
        },
        '& fieldset': {
            borderColor: 'transparent',
        },
        '& .MuiInputBase-input': {
            paddingLeft: 1.5,
        },
    },
    inputAdornment: {
        px: '8px !important',
    },
};
export var EditableCellRenderer = function (params) {
    var api = params.api, context = params.context;
    var _a = useState(false), hovered = _a[0], serHovered = _a[1];
    var _b = useState(false), focused = _b[0], setFocused = _b[1];
    var _c = useState(params.value), val = _c[0], setVal = _c[1];
    var updateValue = function (value) {
        params.node.setDataValue('caption', value);
    };
    var resetValue = function () {
        setVal(params.value);
    };
    var handleKeyDown = function (e) {
        if (e.key === 'Enter') {
            updateValue(val);
        }
        if (e.key === 'Escape' && params.value !== val) {
            e.stopPropagation();
            resetValue();
        }
    };
    var onBlur = function (e) {
        setFocused(false);
        updateValue(val);
        // Check if value is empty. If not, loop over other caption fields, and check them.
        if (e.target.value.trim() === '') {
            context.setAreDataInvalid(true);
        }
        else {
            var areCaptionsInvalid_1 = false;
            api.forEachNode(function (_a) {
                var data = _a.data;
                if (data.caption.trim() === '') {
                    areCaptionsInvalid_1 = true;
                }
            });
            context.setAreDataInvalid(areCaptionsInvalid_1);
        }
    };
    return (React.createElement(CenteredBox, null,
        React.createElement(TextField, { error: val.trim() === '' && !focused, inputProps: {
                'data-testid': "".concat(CMP, "-input-field"),
            }, InputProps: {
                endAdornment: (hovered || focused) && (React.createElement(InputAdornment, { position: "end", sx: styles.inputAdornment, variant: "filled" },
                    React.createElement(Edit16, null))),
            }, onBlur: onBlur, onChange: function (e) { return setVal(e.target.value); }, onFocus: function () { return setFocused(true); }, onKeyDown: handleKeyDown, onMouseEnter: function () { return serHovered(true); }, onMouseLeave: function () { return serHovered(false); }, sx: styles.textField, value: val })));
};
//# sourceMappingURL=EditableCellRenderer.js.map